///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable, Injector } from '@angular/core';
import { GtthUnitInfoComponent } from './unit-info/unit-info.component';
import { createCustomElement } from '@angular/elements';
import { GtthLinkInfoComponent } from './link-info/link-info.component';
import { GtthSelectedAreaInfoComponent } from './select-area/selected-area-info.component';
import { GtthSectorInfoComponent } from './sector-info/sector-info.component';

@Injectable({
    providedIn: 'root'
})
export class InfoWindowsCustomElementRegisterService {
    constructor(private readonly injector: Injector) {}

    registerInfoWindowComponents(): void {
        const injector = this.injector;

        customElements.define(GtthUnitInfoComponent.CUSTOM_ELEMENT_TAG_NAME, createCustomElement(GtthUnitInfoComponent, { injector }));
        customElements.define(GtthLinkInfoComponent.CUSTOM_ELEMENT_TAG_NAME, createCustomElement(GtthLinkInfoComponent, { injector }));
        customElements.define(
            GtthSelectedAreaInfoComponent.CUSTOM_ELEMENT_TAG_NAME,
            createCustomElement(GtthSelectedAreaInfoComponent, { injector })
        );
        customElements.define(GtthSectorInfoComponent.CUSTOM_ELEMENT_TAG_NAME, createCustomElement(GtthSectorInfoComponent, { injector }));
    }
}
